import React, { Component } from "react";
import "./PotentialCustomers.css";

class PotentialCustomers extends Component {
	reformatValue(e) {
		let splitVal = e.target.value.split(", ");
		this.props.buildSearchQuery("potentialCustomers", splitVal);
	}
	render() {
		return (
			<section>
				<p className="panel-section-header">Potential Customers</p>
				<div>
					<small>Separate multiple customers (ticker or url) by a semicolon.</small>
					<br />
					<input
						defaultValue={
							this.props.query["potentialCustomers"] === undefined
								? ""
								: this.props.query["potentialCustomers"]
						}
						onChange={e => this.reformatValue(e)}
						type="text"
						placeholder="e.g. AAPL; amazon.com"
					/>
				</div>
			</section>
		);
	}
}

export default PotentialCustomers;


// WEBPACK FOOTER //
// ./src/components/Search/PanelLeft/CustomersOptions/PotentialCustomers/PotentialCustomers.js